import React, { FC } from 'react';
import classNames from 'classnames';
import { Connect, PropsFromRedux } from './SearchMainContainer';
import { SearchAside } from '../search-aside/SearchAside';
import { SearchSection } from '../search-section/SearchSection';
import { HomeExpiredWizard } from '../../../home-expired/HomeExpiredWizard';
import styles from './search_main.module.scss';
import { LightHelmet } from '../../../components/light-helmet/LightHelmet';
import { buildUrlWithParameters } from '../../../utils/url-utils/urlUtils';
import { getPageName } from '../../../utils/pageName';

type Props = PropsFromRedux;

const RawSearchMain: FC<Props> = ({
  trialExpired,
  quotaExceeded,
  isOpen,
  loaded,
  searchLoading,
  query,
}) => {
  const shouldDisplaySearch = loaded || searchLoading;
  if (!shouldDisplaySearch) {
    return null;
  }

  let title = 'Recherche Doctrine';

  if (quotaExceeded) {
    window.location.href = buildUrlWithParameters('/inscription', {
      source: 'quota-exceeded',
      sourcePage: getPageName(),
    });
  }

  if (trialExpired) {
    title = 'Doctrine - essai terminé';
  } else if (!searchLoading && query) {
    title = `${query} - Recherche Doctrine`;
  }

  return (
    <>
      <LightHelmet title={title} />
      <div className={styles.container}>
        {!trialExpired && (
          <div
            className={classNames(styles.searchContainer, {
              filter__mobile__shown: isOpen,
            })}
          >
            <SearchAside />
            <SearchSection />
          </div>
        )}
        <HomeExpiredWizard />
      </div>
    </>
  );
};

export const SearchMain = Connect(RawSearchMain);
